module.exports = __webpack_public_path__ + "static/personal_accident.afd0fb41.jpg";